
import type { TFunction } from "i18next";
import { Icon } from "../../Icon";

const ContactActionWidget = ({ openingHours, phoneNumber, bookingAction, t }: { openingHours?: string, phoneNumber?: string, bookingAction?: string, t: TFunction }) => {
    if (!openingHours && !phoneNumber && !bookingAction) return null;

    // Hypothetical logic: you can rely on meta.isOperational or a helper for parsing hours
    const isOpen = true; // Here would go the real calculation logic

    return (
        <div className="flex flex-col gap-4 mt-6">
            {/* Opening Hours and Operational Status */}
            {openingHours && (
                <div className="bg-base-200/50 rounded-2xl p-4 border border-base-300/30 flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <div className={`${isOpen ? 'bg-success/10 text-success' : 'bg-error/10 text-error'} rounded-2xl p-2.5 flex items-center justify-center shrink-0 border border-base-200`}>
                            <Icon name={isOpen ? 'check_circle' : 'cancel'} className="text-2xl" />
                        </div>
                        <div>
                            <dt className="text-[10px] font-black uppercase tracking-widest opacity-40">
                                {t('poiModal.openingHours')}
                            </dt>
                            <dd className="text-sm font-bold uppercase">{openingHours}</dd>
                        </div>
                    </div>

                    {/* Status Badge */}
                    <div className={`badge ${isOpen ? 'badge-success' : 'badge-error'} badge-sm font-bold uppercase py-3`}>
                        {isOpen ? t('common.open') : t('common.closed')}
                    </div>
                </div>
            )}

            {/* Quick Actions (Grid) */}
            <div className="grid grid-cols-2 gap-3">
                {phoneNumber && (
                    <a
                        href={`tel:${phoneNumber}`}
                        className="btn btn-outline border-base-300 hover:bg-primary hover:border-primary flex flex-col h-auto py-3 gap-1 normal-case group"
                    >
                        <Icon name="call" className="text-2xl text-primary group-hover:text-primary-content" />
                        <span className="text-[10px] text-primary group-hover:text-primary-content uppercase tracking-tighter opacity-60 group-hover:opacity-100">
                            {t('poiModal.callNow')}
                        </span>
                    </a>
                )}

                {bookingAction && (
                    <a
                        href={bookingAction.startsWith('http') ? bookingAction : `https://${bookingAction}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary flex flex-col h-auto py-3 gap-1 normal-case"
                    >
                        <Icon name="public" className="text-2xl" />
                        <span className="text-[10px] font-black uppercase tracking-tighter">
                            {t('poiModal.website')}
                        </span>
                    </a>
                )}
            </div>
        </div>
    );
};

export default ContactActionWidget;